import React from 'react';

import DOMPurify from 'dompurify';

import styles from './safe-html.module.css';

export const SafeHtml = ({ html }: { html: string }): JSX.Element => {
  const allowedTags = [
    'b',
    'i',
    'em',
    'strong',
    'p',
    'br',
    'span',
    'ul',
    'li',
    'a',
    'h1',
    'h2',
    'h3',
    'h4',
    'h5',
    'h6',
    'blockquote',
    'code',
    'pre',
    'hr',
    'ol',
  ];

  const allowedAttributes = [
    'href',
    'target',
    'rel',
    'class',
    'style',
    'id',
    'title',
    'aria-*',
    'data-*',
    'role',
  ];

  // Use DOMPurify for sanitization with allowed tags and attributes
  const sanitizeHtml = (input: string) => {
    return DOMPurify.sanitize(input, {
      ALLOWED_TAGS: allowedTags,
      ALLOWED_ATTR: allowedAttributes,
      USE_PROFILES: { html: true },
      ADD_ATTR: ['target'],
    });
  };

  return (
    <div className={styles.safeHtml} dangerouslySetInnerHTML={{ __html: sanitizeHtml(html) }} />
  );
};
